"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Hidden = _interopRequireDefault(require("@material-ui/core/Hidden"));

var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));

var _Alarm = _interopRequireDefault(require("@material-ui/icons/Alarm"));

var _icMember = _interopRequireDefault(require("../../../img/ic-member.svg"));

var _icDistanceLarge = _interopRequireDefault(require("../../../img/ic-distance-large.svg"));

var _icUnverifiedLocationSmall = _interopRequireDefault(require("../../../img/ic-unverified-location-small.svg"));

var _verified_green_24dp = _interopRequireDefault(require("../../../img/verified_green_24dp.svg"));

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mileRatio = 0.621371;

var LocatorResult = function LocatorResult(_ref) {
  var result = _ref.result,
      onMouseOver = _ref.onMouseOver,
      onClick = _ref.onClick,
      customDistanceIcon = _ref.customDistanceIcon,
      showCovidVerified = _ref.showCovidVerified;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "locator-result-container",
    onMouseOver: onMouseOver,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_Hidden.default, {
    smUp: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "locator-result-name headlineFont"
  }, result.name)), /*#__PURE__*/_react.default.createElement("div", {
    className: "locator-result-main"
  }, result.isPreferred ? /*#__PURE__*/_react.default.createElement("div", {
    className: "locator-result-preferred-member bodyFont"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "locator-result-preferred-member-image",
    src: _icMember.default,
    alt: "preferred member star"
  }), " Sponsored") : null, /*#__PURE__*/_react.default.createElement(_Hidden.default, {
    xsDown: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "locator-result-name headlineFont"
  }, result.name)), /*#__PURE__*/_react.default.createElement("div", {
    className: "locator-result-distance flex align-items-center ".concat(result.isPreferred ? 'marginTop10' : '')
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "locator-result-distance-image",
    src: customDistanceIcon || _icDistanceLarge.default,
    alt: "distance icon"
  }), _formatMiles(result), result.businessHoursTemporarilyAffected && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
    src: _icUnverifiedLocationSmall.default,
    alt: "unclaimed icon",
    className: "locator-result-biz-hrs marginRight5"
  }), /*#__PURE__*/_react.default.createElement(_Alarm.default, null))), /*#__PURE__*/_react.default.createElement("div", {
    className: "locator-result-address"
  }, /*#__PURE__*/_react.default.createElement("div", null, result.address.line1), /*#__PURE__*/_react.default.createElement("div", null, result.address.city, ", ", result.address.stateCode)), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex"
  }, result.covid_verified && showCovidVerified && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: "This location's data has been verified by NICA"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "locator-result-verified flex align-items-center marginRight20"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _verified_green_24dp.default,
    alt: "Verified"
  }), " Verified")), !result.orgId && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: "This location has not been claimed and verified by the owner."
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "locator-result-unverified flex align-items-center"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _icUnverifiedLocationSmall.default,
    className: "marginRight5",
    alt: "unclaimed icon",
    style: {
      height: 20,
      width: 20
    }
  }), " Unclaimed")))), result.temporarily_closed ? /*#__PURE__*/_react.default.createElement("div", {
    className: "locator-result-temporarily-closed"
  }, "Temporarily Closed") : null);
};

function _formatMiles(result) {
  var miles = mileRatio * result.distance;
  return "".concat(miles.toFixed(), " miles");
}

var _default = LocatorResult;
exports.default = _default;